import { simMod } from './Module.config'
import { getCompanyID, getCompanyName } from './api/api'
import * as LMS from './LMS'
import { User } from './Types'
import { getElectricalCode } from './App.config'

export const getUser = async (): Promise<User> => {
    console.log('Initializing user...')
    const companyID: string = getCompanyID()

    const user: User = {
        userId: LMS.getStudentID() || simMod.userID,
        userName: LMS.getStudentName() || simMod.userName,
        companyId: companyID,
        companyName: await getCompanyName(companyID),
        moduleId: simMod.solverModule,
        electricalCode: getElectricalCode()
    }

    console.table(user)
    return user
}